import React, { useState } from 'react';
import InputText from '../../Atoms/InputText';
import Button from '../../Atoms/Button';

interface Props {
  value?: string;
}

function Clipboard({ value = '' }: Props) {
  const [buttonText, setButtonText] = useState('Kopieer');

  return (
    <div className="flex @container">
      <div className="shrink grow">
        <InputText
          label=""
          defaultValue={value}
          readonly
          className="-mr-4"
        />
      </div>
      <div className="relative z-10 shrink-0 basis-32 @lg:basis-36">
        <Button
          shadow
          text={buttonText}
          fluid
          color="secondary"
          className="!h-[48px] md:!h-[52px]"
          onClick={() => {
            navigator.clipboard.writeText(value);

            setButtonText('Gekopieerd!');

            setTimeout(() => {
              setButtonText('Kopieer');
            }, 1000);
          }}
        />
      </div>
    </div>
  );
}

export default Clipboard;
